<template>
    <div class="box-second" >
        <p class="title-crumb" style="justify-content: space-between;padding-right:1vw;">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>设备监测</el-breadcrumb-item>
                <el-breadcrumb-item>塔吊监测</el-breadcrumb-item>
            </el-breadcrumb>   
            <!-- <el-button style="margin-left: 70%;" type="primary" size="mini" @click="baseconfig()">基本参数配置</el-button>
            <el-button type="warning" size="mini" @click="config()">参数配置</el-button>
            <el-button type="info" size="mini" @click="breat()">设备心跳参数</el-button> -->
            
        </p>
        <div class="main">
            <div class="main-left">
                <div class="main-left-item" v-for="(item,index) in towerlist" :key="index" :class="{'curTower':towerId==item.id}" @click="changeTower(item)">
                    <p class="name nowrap">{{item.name}}</p>
                    <p class="state color8" v-if="item.connectedStatus=='离线'">离线</p>
                    <p class="state color10" v-else-if="item.connectedStatus=='正常'" >正常</p>
                    <p class="state color9" v-else >{{item.connectedStatus}}</p>
                    <p class="num"><span class="nowrap" :title="item.deviceId">设备编号：{{item.deviceId}}</span></p>
                </div>
            </div>
            <div class="main-right">
                <div class="main-right-first">
                    <div class="real-data" style="width:42%;">
                        <p style="text-align: left;padding-left:1vh;font-size:1vw;height:3vh;width:100%;text-align: center;">实时数据</p>
                        <div class="tower-data" style="width:100%;height:calc( 100% - 7vh );position: relative;padding:2vh 0;">
                            <p style="height: 4vh;text-align: left;">更新时间：{{allPart.updateDate}}</p>
                            <el-table :data="valData" border style="width: 100%" :show-header="false">
                                <el-table-column prop="index1" label="index"></el-table-column>
                                <el-table-column prop="name1" label="姓名"></el-table-column>
                                <el-table-column prop="val1" label="地址">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.val1 }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="index2" label="index"></el-table-column>
                                <el-table-column prop="name2" label="姓名"></el-table-column>
                                <el-table-column prop="val2" label="地址">
                                    <template slot-scope="scope">
                                        <span>{{ scope.row.val2 }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="real-clock">
                        <p style="text-align: left;padding-left:1vh;font-size:1vw;height:3vh;width:100%;text-align: center;">塔吊设备回转</p>
                        <div class="real-clock-con" id="wrap">
                            <ul id="list">
                                <li></li><li></li><li></li><li></li><li></li><li></li>
                                <li></li><li></li><li></li><li></li><li></li><li></li>
                                <li></li><li></li><li></li><li></li><li></li><li></li>
                                <li></li><li></li><li></li><li></li><li></li><li></li>
                                <li></li><li></li><li></li><li></li><li></li><li></li>
                                <li></li><li></li><li></li><li></li><li></li><li></li>
                                <li></li><li></li><li></li><li></li><li></li>
                                <li></li><li></li><li></li><li></li><li></li>
                                <li></li><li></li><li></li><li></li><li></li><li></li>
                                <li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li>
                            </ul>
                            <div class="icon"></div>
                            <div
                                id="clockLine"
                                :style="{'-webkit-transform': 'rotate('+allPart.angle+'deg)'}"
                            ></div>
                            <div class="num0">0</div>
                            <div class="num90">90</div>
                            <div class="num180">180</div>
                            <div class="num270">270</div>
                        </div>
                    </div>
                    <div class="real-data">
                        <p style="text-align: left;padding-left:1vh;font-size:1vw;height:3vh;width:100%;text-align: center;">吊钩可视化</p>
                        <div v-if="cameraData && cameraData.serial" style="width:100%;height:calc( 100% - 8vh );position: relative;">
                            <iframe width="100%" height="100%" :src='showUrl' style="border: 0;height: 100%;"></iframe>
                        </div>
                        <div v-else style="width:100%;height:calc( 100% - 8vh );position: relative;">
                            <img src="../../../assets/image/monitorBg.png" style="width:100%;height:100%;" />
                            <p style="width:100%;height:4vh;text-align: center;position: absolute;top:65%;left:0;">暂无视频</p>
                        </div>
                        <p class="item-info" v-if="cameraData && cameraData.name">
                            <span class="name nowrap">{{cameraData.name}}</span>
                            <img v-if="cameraData.type=='1'" src="../../../assets/image/gun.png" />
                            <img v-else-if="cameraData.type=='2'" src="../../../assets/image/ptz.png" />
                            <span style="margin-right: 1vw;cursor: pointer;" @click="toDetail(cameraData.serial,cameraData.channelNo,cameraData.type,cameraData.id)">操作</span>
                        </p>
                    </div>
                </div>
                <!--  -->
                <div style="width:100%;height:calc( 100% - 33vh );position: relative;background:#fff;margin-top:1vh;border-radius: 5px;padding:1vh;display:flex;flex-wrap:wrap;">
                    <div style="width:100%;height:4vh;position: relative;display:flex;justify-content: space-between;align-items: flex-start;">
                        <span >最近预警记录</span>
                        <el-button size="mini" type="primary" @click="toMore">更多</el-button>
                    </div>
                    <div style="width:50%;height:calc( 100% - 4vh );position: relative;display:flex;flex-wrap:wrap;align-content: flex-start;">
                        <div v-for="(item,index) in warnList" :key="index" style="width:100%;height:6vh;position: relative;display:flex;align-content: center;margin-bottom: 2vh;align-items: center;background:#E7F1FB;border-radius: 4px;">
                            <div style="width:6vh;height:6vh;position: relative;background:#E5E5E5;display:flex;justify-content: center;align-items: center;">
                                <img :src="item.icon" style="max-width:6vh;max-height:6vh;" />
                            </div>
                            <p style="padding-left:0.5vh;width:15vh;position: relative;text-align: left;font-size:0.8vw;">{{item.name}}</p>
                            <p style="padding-left:0.5vh;width:19vh;position: relative;text-align: left;color:red;font-size:0.8vw;">超预警限位:{{item.val}} {{item.unit}}</p>
                            <p style="width:calc( 100% - 40vh );position: relative;text-align: center;font-size:0.8vw;">报警时间：{{item.createDate}}</p>
                        </div>
                        <!-- <div style="width:100%;height:6vh;position: relative;display:flex;align-content: center;margin-bottom: 2vh;align-items: center;background:#E7F1FB;border-radius: 4px;">
                            <div style="width:6vh;height:6vh;position: relative;background:#E5E5E5;display:flex;justify-content: center;align-items: center;">
                                <img src="../../assets/image/icon/kg.png" style="max-width:6vh;max-height:6vh;" />
                            </div>
                            <p style="padding-left:0.5vh;width:15vh;position: relative;text-align: left;font-size:0.8vw;">超重报警</p>
                            <p style="padding-left:0.5vh;width:19vh;position: relative;text-align: left;color:red;font-size:0.8vw;">超预警限位:36度</p>
                            <p style="width:calc( 100% - 40vh );position: relative;text-align: center;font-size:0.8vw;">报警时间：2020-01-05 12:23:45</p>
                        </div> -->
                    </div>
                    <div style="width:50%;height:calc( 100% - 4vh );position: relative;display:flex;overflow: hidden;">
                        <div style="width:50%;height:100%;position: relative;">
                            <div id="realDura" style="width:100%;height:100%"></div>
                        </div>
                        <div style="width:50%;height:100%;position: relative;">
                            <div id="realDura1" style="width:100%;height:100%"></div>
                        </div>
                    </div>
                </div>
                <!-- 特种设备操作人员列表 -->
                <div class="main-right-first" style="margin-top:1vh;height:auto;padding:1vh;">
                    <p style="text-align: left;padding:0 1vh;font-size:1vw;height:3vh;width:100%;display:flex;justify-content: space-between;align-items: center;">
                        <span>特种设备操作人员列表</span>
                        <el-date-picker
                          v-model="tableTime"
                          value-format="yyyy-MM-dd"
                          type="date"
                          @change="doFilter"
                          placeholder="选择日期">
                        </el-date-picker>
                    </p>
                    <div class="special-table">
                        <el-table
                            :data="tableData"
                            style="width: 100%">
                            <el-table-column
                                prop="index"
                                label="序号">
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                label="姓名">
                            </el-table-column>
                            <el-table-column
                                prop="certificateNumber"
                                label="证件编号">
                            </el-table-column>
                            <el-table-column
                                prop="certificatePhoto"
                                label="查看证书">
                                <template slot-scope="scope">
                                    <el-image
                                        v-if="scope.row.certificatePhoto!=''"
                                        style="width: 6vh; height: 6vh;"
                                        :src="scope.row.certificatePhoto"
                                        :preview-src-list="scope.row.photoList"
                                    ></el-image>
                                    <div v-else class="no-photo" style="display: inline-block;">
                                        <span style="display: block;">暂无</span>
                                        <span style="display: block;">图片</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作记录" width="400">
                                <template slot-scope="scope">
                                    <div style="height:100px;display: flex;align-content: center;align-items: center;justify-content: center;">
                                        <el-image
                                            v-if="scope.row.photoFile!=''"
                                            style="width: 6vh; height: 6vh;"
                                            :src="scope.row.photoFile"
                                            :preview-src-list="scope.row.photoList"
                                        ></el-image>
                                        <span style="margin-left:1vh;">时间：{{scope.row.clockTime}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>
        <!-- 维护标准窗口 -->
        <el-dialog
            title="参数配置"
            :visible.sync="editFormVisible"
            center
            :append-to-body="true"
            :lock-scroll="false"
            custom-class='tower-dig'
            class="add-form"
            width="60%"
        >
          <div class="config-con">
            <p class="config-con-item" v-for="(item,index) in configList" :key="index">
              <span style="display: inline-block;width: 8vw;">{{item.name}}
                  <i v-if="item.tip" class="el-icon-info" style="color:#E6A23C;" :title="item.tip"></i>
              </span>
              <span style="display: inline-block;width: 8vw;">单位：（{{item.unit}}）</span>
              <span v-if="item.tip" style="display: inline-block;width: 25vw;color:#E6A23C;">设备预警限位：<el-input v-model="item.val" placeholder="请输入" style="width:10vw;"></el-input> {{item.unit}}</span>
              <span v-else style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="item.val" placeholder="请输入" style="width:10vw;"></el-input> {{item.unit}}</span>
            </p>
          </div>
          <div slot="footer" class="dialog-footer">
              <el-button @click="editFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitEditRow">确 定</el-button>
              <el-button type="info" @click="setDetfaule">恢复默认值</el-button>
          </div>
        </el-dialog>
        <!-- 基本参数配置 -->
        <el-dialog
            title="基本参数配置"
            :visible.sync="configFormVisible"
            center
            :append-to-body="true"
            :lock-scroll="false"
            custom-class='tower-dig'
            class="add-form"
            width="80%"
        >
          <div class="config-con">
              <div style="width:50%" >
                <p style="font-weight: bolder;color: #e6a23c;">高度传感器</p>
                <p class="item-one" >
                  <span style="display: inline-block;width: 10vw;">高度传感器上限
                  </span>
                  <span style="display: inline-block;width: 8vw;">单位：</span>
                  <span style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="heightSensor.height_max" placeholder="请输入" style="width:10vw;"></el-input> </span> 
                </p>

                <p  class="item-one" >
                  <span style="display: inline-block;width: 10vw;">高度传感器下限
                  </span>
                  <span style="display: inline-block;width: 8vw;">单位：</span>
                  <span style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="heightSensor.height_min" placeholder="请输入" style="width:10vw;"></el-input> </span> 
                </p>

                <p  class="item-one" >
                  <span style="display: inline-block;width: 10vw;">吊钩距大臂距离
                  </span>
                  <span style="display: inline-block;width: 8vw;">单位：(米)</span>
                  <span style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="heightSensor.height_max_distance" placeholder="请输入" style="width:10vw;"></el-input> </span> 
                </p>

                <!-- <p  class="item-one" >
                  <span style="display: inline-block;width: 10vw;">吊钩距离大臂下限
                  </span>
                  <span style="display: inline-block;width: 8vw;">单位：(米)</span>
                  <span style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="heightSensor.height_min_distance" placeholder="请输入" style="width:10vw;"></el-input> </span> 
                </p> -->
              </div>

              <div style="width:50%">
                <p style="font-weight: bolder;color: #e6a23c;">幅度传感器</p>
                <p class="item-one" >
                  <span style="display: inline-block;width: 15vw;">幅度传感器远限
                  </span>
                  <span style="display: inline-block;width: 8vw;">单位：</span>
                  <span style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="radiusSensor.radius_max" placeholder="请输入" style="width:10vw;"></el-input> </span> 
                </p>

                <p  class="item-one" >
                  <span style="display: inline-block;width: 15vw;">幅度传感器近限
                  </span>
                  <span style="display: inline-block;width: 8vw;">单位：</span>
                  <span style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="radiusSensor.radius_min" placeholder="请输入" style="width:10vw;"></el-input> </span> 
                </p>

                <p  class="item-one" >
                  <span style="display: inline-block;width: 15vw;">小车离驾驶舱距离
                  </span>
                  <span style="display: inline-block;width: 8vw;">单位：(米)</span>
                  <span style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="radiusSensor.radius_max_distance" placeholder="请输入" style="width:10vw;"></el-input> </span> 
                </p>

                <!-- <p  class="item-one" >
                  <span style="display: inline-block;width: 15vw;">幅度传感器小车距离下限
                  </span>
                  <span style="display: inline-block;width: 8vw;">单位：(米)</span>
                  <span style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="radiusSensor.radius_min_distance" placeholder="请输入" style="width:10vw;"></el-input> </span> 
                </p>
               -->
              
              </div>
          </div>
          <div slot="footer" class="dialog-footer">
              <el-button @click="configFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="configRow">确 定</el-button>
              <!-- <el-button type="info" @click="setDetfaule">恢复默认值</el-button> -->
          </div>
        </el-dialog>
        <!-- 设备心跳参数 -->
        <el-dialog
        title="设备心跳参数"
        :visible.sync="beatFormVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        custom-class='tower-dig'
        class="add-form"
        width="30%"
    >
      <div class="config-con">
          <div style="width:100%" >
            <p class="item-one" >
              <span style="display: inline-block;width: 25vw;">高度传感器
              </span>
              <span style="display: inline-block;width: 50vw;color:#409EFF;">值：<el-input v-model="beatForm.heightSensor" placeholder="" style="width:10vw;"></el-input> </span> 
            </p>

            <p  class="item-one" >
              <span style="display: inline-block;width: 25vw;">回转传感器
              </span>
              <span style="display: inline-block;width: 50vw;color:#409EFF;">值：<el-input v-model="beatForm.angleSensor" placeholder="" style="width:10vw;"></el-input> </span> 
            </p>

            <p  class="item-one" >
              <span style="display: inline-block;width: 25vw;">幅度传感器
              </span>
              <span style="display: inline-block;width: 50vw;color:#409EFF;">值：<el-input v-model="beatForm.radiusSensor" placeholder="" style="width:10vw;"></el-input> </span> 
            </p>

            <p  class="item-one" >
              <span style="display: inline-block;width:25vw;">重量传感器
              </span>
              <span style="display: inline-block;width:50vw;color:#409EFF;">值：<el-input v-model="beatForm.loadweightrSensor" placeholder="" style="width:10vw;"></el-input> </span> 
            </p>
            <p  class="item-one" >
              <span style="display: inline-block;width:25vw;">风速传感器
              </span>
              <span style="display: inline-block;width:50vw;color:#409EFF;">值：<el-input v-model="beatForm.windspeedSensor" placeholder="" style="width:10vw;"></el-input> </span> 
            </p>
            <p  class="item-one" >
              <span style="display: inline-block;width:25vw;">倾角传感器
              </span>
              <span style="display: inline-block;width:50vw;color:#409EFF;">值：<el-input v-model="beatForm.fallSensor" placeholder="" style="width:10vw;"></el-input> </span> 
            </p>
            <p  class="item-one" >
              <span style="display: inline-block;width:25vw;">
                按钮传感器
              </span>
              <span style="display: inline-block;width:50vw;color:#409EFF;">值：<el-input v-model="beatForm.buttonSensor" placeholder="" style="width:10vw;"></el-input> </span> 
            </p>
          </div>

          
      </div>
    </el-dialog>

    </div>
</template>
<script>
import HighCharts from 'highcharts'
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
    data(){
        return{
            groupId:'',
            towerId:'',//当前塔吊id
            deviceId:'',//当前塔吊deviceId
            towerlist:[],//塔吊设备列表
            allPart:{},//当前塔吊信息
            valData:[  //实时数据列表
                { index1:'1',name1:'设备幅度',val1:'0',index2:'4',name2:'塔吊力矩',val2:'0'},
                { index1:'2',name1:'额定吊重',val1:'0',index2:'5',name2:'吊重',val2:'0' },
                { index1:'3',name1:'吊钩高度',val1:'0',index2:'6',name2:'前倾角',val2:'0' },
            ],
            towerH:{},//24小时数据
            tableData:[],//特种人员列表
            websock: null,
            // timeRefrsh:null,
            showUrl:'',
            cameraData:{},//监控摄像头信息
            tableTime:util.myTime.getCurTime(),

            //参数配置
            editFormVisible:false,
            configList:[
                {name:'回转限位预警',unit:'度',val:'',status:true,default:'864',tip:'最大设置971度',key:'angle'},
                {name:'幅度限位预警',unit:'米',val:'',status:true,default:'30',tip:'最大设置90%臂长',key:'radius'},
                {name:'高度限位预警',unit:'米',val:'',status:true,default:'1',tip:'高度限位预警指的是，塔吊力臂与吊钩之间的距离，距离力臂越近越容易预警，最低值是0.5米',key:'hight'},
                {name:'吊重限位预警',unit:'百分比',val:'',status:true,default:'80',tip:'最大设置为额定吊重的94%',key:'loadweightr'},
                {name:'力矩预警',unit:'百分比',val:'',status:true,default:'80',tip:'最大设置为94%',key:'lijupercent'},
                {name:'风速预警',unit:'米每秒',val:'',status:true,default:'10.8',tip:'最大设置为7级风13.8m/s',key:'windspeed'},
                {name:'倾斜预警',unit:'度',val:'',status:true,default:'10',tip:'最大设置为10度',key:'fall'},
                {name:'防碰撞预警',unit:'米',val:'',status:true,default:'10',tip:'最大设置10米',key:'ratedWeight',},
                {name:'额定吊重',unit:'吨',val:'',key:'ratedWeight'},
                {name:'IP地址',unit:'',val:'',key:'ipAddress'},
                {name:'4g卡号',unit:'',val:'',key:'cardNumber'},
                {name:'频率',unit:'分',val:'',key:'frequency'},
                {name:'摄像头ip',unit:'',val:'',key:'cameraIp'},
                {name:'臂长',unit:'米',val:'',key:'armLength'},
                {name:'焦距变倍距离',unit:'倍',val:'',key:'focalLength'},
                {name:'额定高度',unit:'米',val:'',key:'heightRating'},
                {name:'标准力矩',unit:'百分比',val:'',key:'standardTorque'},
                {name:'塔吊坑深',unit:'米',val:'',key:'deepPit'},
            ],
            configData:{
                id:'',
                projectId:'',
                projectName:'',
                angleSwitch:'1',  //回转开关   1开  2关
                angle:'',        //回转
                radiusSwitch:'1',    // 幅度  开关  1开  2关
                radius:'',          // 幅度
                hightSwitch:'1',   //高度开关
                hight:'',         //高度
                loadweightrSwitch:'1',  //吊重开关
                loadweightr:'',  //吊重
                lijupercentSwitch:'1',  // 力矩百分比  开关
                lijupercent:'',     //力矩百分比
                windspeedSwitch:'1', //风速开关
                windspeed:'',    //风速
                fallSwitch:'1', //倾角 开关
                fall:'',//倾角
                createBy:'',
                deviceId:'',//设备序列号
                ratedWeight:'', //额定吊重
                ipAddress:'',//IP地址
                cardNumber:'',//4g卡号
                frequency:'',//频率（s）
                cameraIp:'',//摄像头ip
                armLength:'',//臂长
                focalLength:'',//焦距变倍距离
                heightRating:'',//高度额定值
                standardTorque:'',//标准力矩
                deepPit:'',//塔吊坑深
            },
            heightSensor:{
              height_max:'', //高度传感器上限
              height_min:'',//高度传感器下限
              height_max_distance:'',//吊钩距离大臂上限
              height_min_distance:'',//吊钩距离大臂下限
            },
            radiusSensor:{
              radius_max:'',//幅度传感器上限
              radius_min:'',//幅度传感器下限
              radius_max_distance:'',//幅度传感器小车距离上限
              radius_min_distance:'',//幅度传感器小车距离下限
            },
            warnList:[],//列表
            configFormVisible:false,
            beatFormVisible:false,
            beatForm:{

            }
        }
    },
    mounted(){
        var　params = this.$route.params
        this.groupId = params.id
        this.getTowerList()
        // this.groupId = util.session.get('groupId')
        // this.getTowerList()
        this.setChart1({})
        this.setChart2({})
    },
    created(){
        //页面刚进入时开启长连接
        
    },
    destroyed: function() {
        //页面销毁时关闭长连接
        //this.websocketclose();
        // if(this.timeRefrsh){
        //     window.clearTimeout(this.timeRefrsh)
        // }
    },
    methods:{
        //获取塔吊设备
        getTowerList(){
            var that = this
            myHttp.getTowerListByPage({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.towerList||[]
                    for(var i=0;i<list.length;i++){
                        if(list[i].machType=='3'){
                            list[i].online = list[i].connectedStatus && ''!=list[i].connectedStatus?list[i].connectedStatus:'离线'
                        }else{
                            if(list[i].status=='0'){
                                list[i].online = '离线'
                            }else if(list[i].status=='1'){
                                list[i].online = '在线'
                            }else{
                               list[i].online = '异常'
                            }
                        }
                        
                    }
                    that.towerlist = list
                    if(list.length>0 && that.towerId==''){
                        that.towerId = list[0].id
                        that.deviceId = list[0].deviceId
                        that.initWebSocket()
                    }
                    if(that.towerId!=''){
                        that.getRealInfo()
                        that.getHour()
                        that.getNum()
                        that.getPerson()
                        that.getWarnLast()
                    }else{
                        that.setChart1({})
                    }
                }
            })
        },
        getRealInfo(){
            var that = this
            myHttp.getTowerInfoByPage({
                id:this.towerId,
                v:new Date().getTime()
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.tower||{}
                    data.angle = data.angle && ''!=data.angle?data.angle:0
                    that.allPart = data
                    that.valData[0].val1 = data && data.radius &&data.radius!=''?parseFloat(data.radius).toFixed(2)+'m':'0m'
                    that.valData[0].val2 = data && data.lijupercent &&data.lijupercent!=''?parseFloat(data.lijupercent).toFixed(1)+'%':'0%'
                    that.valData[1].val1 = data && data.ratedWeight &&data.ratedWeight!=''?parseFloat(data.ratedWeight).toFixed(0)+'T':'0T'
                    that.valData[1].val2 = data && data.loadweightr &&data.loadweightr!=''?parseFloat(data.loadweightr).toFixed(2)+'T':'0T'
                    that.valData[2].val1 = data && data.hight &&data.hight!=''?parseFloat(data.hight).toFixed(2)+'m':'0m'
                    that.valData[2].val2 = data && data.fall &&data.fall!=''?parseFloat(data.fall).toFixed(2)+'°':'0°'
                    that.cameraData = data.camera||{}
                    // console.log(that.cameraData)
                    if(data.camera){
                        that.getVideo(data.camera.serial,data.camera.channelNo)
                    }
                }
                // that.timeRefrsh = setTimeout(function(){
                //     that.getRealInfo()
                // },60000)
            })
        },
        //获取监控视频
        getVideo(serial,channel){
            var that = this
            myHttp.getYsToken({
              projectId: this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var ysToken = resp.data.data.accessToken||''
                    that.showUrl = '/monitor/view/one.html?serial='+serial+'&channel='+channel+'&token='+ysToken
                }
            })
        },

        //获取数据
        getWarnLast(){
            var that = this
            myHttp.recentWarning({
                projectId:this.groupId,
                deviceId:this.deviceId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = []
                    var data = resp.data.data
                    if(data.loadweightr && data.loadweightrTime){
                        var obj1 = {
                            icon : require('../../../assets/image/icon/gd.png'),
                            name : '高度预警',
                            val : parseFloat(data.loadweightr).toFixed(2)||0,
                            unit : '米',
                            createDate:data.loadweightrTime||''
                        }
                        list.push(obj1)
                    }
                    if(data.fall && data.fallTime){
                        var obj2 = {
                            icon : require('../../../assets/image/icon/qs.png'),
                            name : '倾斜报警',
                            val : parseFloat(data.fall).toFixed(2)||0,
                            unit : '度',
                            createDate:data.fallTime||''
                        }
                        list.push(obj2)
                    }
                    if(data.lijupercent && data.lijupercentTime){
                        var obj3 = {
                            icon : require('../../../assets/image/icon/lj.png'),
                            name : '力矩报警',
                            val : parseFloat(data.lijupercent).toFixed(2)||0,
                            unit : '百分比',
                            createDate:data.lijupercentTime||''
                        }
                        list.push(obj3)
                    }
                    if(data.radius && data.radiusTime){
                        var obj4 = {
                            icon : require('../../../assets/image/icon/fd.png'),
                            name : '幅度报警',
                            val : parseFloat(data.radius).toFixed(2)||0,
                            unit : '米',
                            createDate:data.radiusTime||''
                        }
                        list.push(obj4)
                    }
                    if(data.windspeed && data.windspeedTime){
                        var obj5 = {
                            icon : require('../../../assets/image/icon/fs.png'),
                            name : '风速报警',
                            val : parseFloat(data.windspeed).toFixed(2)||0,
                            unit : '米每秒',
                            createDate:data.windspeedTime||''
                        }
                        list.push(obj5)
                    }
                    if(data.hight && data.hightTime){
                        var obj6 = {
                            icon : require('../../../assets/image/icon/gd.png'),
                            name : '吊钩高度报警',
                            val : parseFloat(data.hight).toFixed(2)||0,
                            unit : '米',
                            createDate:data.hightTime||''
                        }
                        list.push(obj6)
                    }
                    if(data.angle && data.angleTime){
                        var obj5 = {
                            icon : require('../../../assets/image/icon/hz.png'),
                            name : '回转报警',
                            val : parseFloat(data.angle).toFixed(2)||0,
                            unit : '度',
                            createDate:data.angleTime||''
                        }
                        list.push(obj5)
                    }
                    that.warnList = list
                }
            })
        },

        //获取24小时监测数据
        getHour(){
            var that = this
            myHttp.get24HourByTower({
                projectId:this.groupId,
                deviceId:this.deviceId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.tdTime
                    // that.towerH = data
                    that.setChart1(data)
                    // that.setChart2(data)
                }
            })
        },
        //24小时监测时长
        setChart1(obj){
            var data = {
                zlyj:obj.zlyj||0,
                fsyj:obj.fsyj||0,
                qxyj:obj.qxyj||0,
                gdyj:obj.gdyj||0,
                ljyj:obj.ljyj||0,
                hzyj:obj.hzyj||0,
                fdyj:obj.fdyj||0,
                // pzyj:obj.pzyj||0
            }
            var all = parseInt(data.zlyj)+parseInt(data.qxyj)+parseInt(data.ljyj)+parseInt(data.fdyj)+parseInt(data.fsyj)+parseInt(data.gdyj)+parseInt(data.hzyj)
            var option = {
                title:{
                    text:all,
                    textStyle:{
                        fontSize:'30',
                        fontWeight:'bold'
                    },
                    subtext:'24小时预警',
                    subtextStyle:{
                        fontSize:'16',
                        color:'#333',
                    },
                    left:'center',
                    top:'middle',
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: 10,
                    data: ['超重报警', '倾斜报警', '力矩预警', '幅度预警', '风速预警', '吊钩高度报警', '回转预警','碰撞报警'],
                    show:false,
                },
                color: ['#09B0B6', '#8973FC', '#FE7396', '#038BF9','#FCD537','#FD9142','#FF3B3B','#5DDCFF'],
                series: [
                    {
                        name: '24小时预警',
                        type: 'pie',
                        center:['50%','50%'],
                        radius: ['50%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: '30',
                                fontWeight: 'bold'
                            }
                        },

                        labelLine: {
                            show: false
                        },
                        data: [
                            {value: data.zlyj, name: '超重预警'},
                            {value: data.qxyj, name: '倾斜预警'},
                            {value: data.ljyj, name: '力矩预警'},
                            {value: data.fdyj, name: '幅度预警'},
                            {value: data.fsyj, name: '风速预警'},
                            {value: data.gdyj, name: '吊钩高度报警'},
                            {value: data.hzyj, name: '回转预警'},
                            // {value: data.pzyj, name: '碰撞报警'},
                        ]
                    }
                ]
            };
            var page = this.$echarts.init(document.getElementById('realDura'))
            page.setOption(option)
        },

        //获取总预警数量
        getNum(){
            var that = this
            myHttp.towerCumulative({
                projectId:this.groupId,
                deviceId:this.deviceId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.tdTime
                    that.setChart2(data)
                }
            })
        },

        //总数统计
        setChart2(obj){
            var data = {
                zlyj:obj.zlyj||0,
                fsyj:obj.fsyj||0,
                qxyj:obj.qxyj||0,
                gdyj:obj.gdyj||0,
                ljyj:obj.ljyj||0,
                hzyj:obj.hzyj||0,
                fdyj:obj.fdyj||0,
                // pzyj:obj.pzyj||0
            }
            var all = parseInt(data.zlyj)+parseInt(data.qxyj)+parseInt(data.ljyj)+parseInt(data.fdyj)+parseInt(data.fsyj)+parseInt(data.gdyj)+parseInt(data.hzyj)
            var option = {
                title:{
                    text:all,
                    textStyle:{
                        fontSize:'30',
                        fontWeight:'bold'
                    },
                    subtext:'总报警记录',
                    subtextStyle:{
                        fontSize:'16',
                        color:'#333',
                    },
                    left:'center',
                    top:'middle',
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: 10,
                    data: ['超重报警', '倾斜报警', '力矩预警', '幅度预警', '风速预警', '吊钩高度报警', '回转预警','碰撞报警'],
                    show:false,
                },
                color: ['#09B0B6', '#8973FC', '#FE7396', '#038BF9','#FCD537','#FD9142','#FF3B3B','#5DDCFF'],
                series: [
                    {
                        name: '预警统计',
                        type: 'pie',
                        center:['50%','50%'],
                        radius: ['50%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: false,
                                fontSize: '30',
                                fontWeight: 'bold'
                            }
                        },

                        labelLine: {
                            show: false
                        },
                        data: [
                            {value: data.zlyj, name: '超重预警'},
                            {value: data.qxyj, name: '倾斜预警'},
                            {value: data.ljyj, name: '力矩预警'},
                            {value: data.fdyj, name: '幅度预警'},
                            {value: data.fsyj, name: '风速预警'},
                            {value: data.gdyj, name: '吊钩高度报警'},
                            {value: data.hzyj, name: '回转预警'},
                            // {value: data.pzyj, name: '碰撞报警'},
                        ]
                    }
                ]
            };
            var page = this.$echarts.init(document.getElementById('realDura1'))
            page.setOption(option)
        },

        //获取人员操作记录
        getPerson(){
            var that = this
            myHttp.getTzListByTeamsId({
                projectId:this.groupId,
                teamsId:this.getTeamId(this.deviceId),
                daysss:this.tableTime,
                status:'1',
                attendanceSn:this.getSn(this.deviceId)
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.attendList||[]
                    for(var i=0;i<list.length;i++){
                        list[i].certificatePhoto = list[i].certificatePhoto && list[i].certificatePhoto!=''?base.httpCtx+list[i].certificatePhoto:''
                        list[i].photoList = []
                        if(list[i].certificatePhoto!=''){
                            list[i].photoList.push(list[i].certificatePhoto)
                        }
                        list[i].photoFile = list[i].photoFile && ''!=list[i].photoFile?base.httpCtx+list[i].photoFile:''
                        if(list[i].photoFile!=''){
                            list[i].photoList.push(list[i].photoFile)
                        }
                        list[i].index = (i+1)
                    }
                    that.tableData = list
                }
            })
        },
        //获取班组id
        getTeamId(id){
            var list = this.towerlist
            var result = ''
            for(var i=0;i<list.length;i++){
                if(id==list[i].deviceId){
                    result = list[i].teamsId
                }
            }
            return result
        },
        //获取sn
        getSn(id){
            var list = this.towerlist
            var result = ''
            for(var i=0;i<list.length;i++){
                if(id==list[i].deviceId){
                    result = list[i].attendanceSn
                }
            }
            return result
        },

        //选择塔吊
        changeTower(obj){
            this.towerId = obj.id
            this.deviceId = obj.deviceId
            // window.clearTimeout(this.timeRefrsh)
            this.getRealInfo()
            this.getHour()
            this.getNum()
            this.getPerson()
            // this.websocket.close();
            // this.initWebSocket()
            this.getWarnLast()
        },

        //跳转查看信息
        attendInfo(row){
            this.$router.push({ name: 'specialPerson',params:{id:this.towerId,personId:row.personId,status:'1'} })
        },

        //跳转监控信息页面
        toDetail(id,channel,type,mid){
            this.$router.push({path:'/monitCtl/'+id+'/'+channel+'/'+type+'/'+mid})
        },

        //
        doFilter(){
            this.getPerson()
        },
        // 跳转预警监测页面
        deatilWarn(){
            var id = this.deviceId
            console.log(id)
            if(this.deviceId){
              this.$router.push({path:'/perWarn/'+id})
            }else{
              this.$message.error('暂无更多')
            }
        },
        //initWebSocket长连接
        initWebSocket(){ 
            if(this.websock){
                this.websock.close();     
            }
            var that = this
            //初始化weosocket 
            if('WebSocket' in window){
                var url = ''
                if(document.location.protocol=="https:"){
                    url = base.httpsWs+"/webSocketEquip/"+this.deviceId;//wss地址;
                }else{
                    url = base.httpWs+"/webSocketEquip/"+this.deviceId;//ws地址;
                }
                // var url=base.httpWs+"/webSocketEquip/"+this.groupId;//ws地址;
                this.websocket = new WebSocket(url);
            }
            else{
                alert('Not support websocket')
            }
            //连接发生错误的回调方法
            this.websocket.onerror = function(){
                //setMessageInnerHTML("error");
            };
            //连接成功建立的回调方法
            this.websocket.onopen = function(event){
                //$("#serverinfo").hide();
                that.errorFlag = false
                that.timeOutObj=null;
            }
            //接收到消息的回调方法
            this.websocket.onmessage = function(event){
                if(event.data=="连接成功")return;
                var x=JSON.parse(event.data);
                if(x.tower.deviceId==that.deviceId){
                    var data = x.tower
                    that.angle = data.angle && ''!=data.angle?data.angle:0
                    that.allPart = data
                    console.log('转角：'+that.allPart.angle+'====高度='+that.allPart.hight)
                    that.valData[0].val1 = data && data.radius &&data.radius!=''?parseFloat(data.radius).toFixed(2)+'m':'0m'
                    that.valData[0].val2 = data && data.lijupercent &&data.lijupercent!=''?parseFloat(data.lijupercent).toFixed(1)+'%':'0%'
                    that.valData[1].val1 = data && data.ratedWeight &&data.ratedWeight!=''?parseFloat(data.ratedWeight).toFixed(0)+'T':'0T'
                    that.valData[1].val2 = data && data.loadweightr &&data.loadweightr!=''?parseFloat(data.loadweightr).toFixed(2)+'T':'0T'
                    that.valData[2].val1 = data && data.hight &&data.hight!=''?parseFloat(data.hight).toFixed(2)+'m':'0m'
                    that.valData[2].val2 = data && data.fall &&data.fall!=''?parseFloat(data.fall).toFixed(2)+'°':'0°'
                    
                }
            }
            //连接关闭的回调方法
            this.websocket.onclose = function(){
                this.timeOutObj=setTimeout(function(){
                    that.initWebSocket();
                }, 60000);
                // $("#serverinfo").show();
                that.errorFlag = true
            }
            //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
            window.onbeforeunload = function(){
                that.websocket.close();
            }
        },

        //数据转列表
        setConfigList(data){
            for(var i=0;i<this.configList.length;i++){
                this.configList[i].val = data[this.configList[i].key]
                // if(i==0){
                // this.configList[i].val = data.angle
                // }else if(i==1){
                //     this.configList[i].val = data.radius
                // }else if(i==2){
                //     this.configList[i].val = data.hight
                // }else if(i==3){
                //     this.configList[i].val = data.loadweightr
                // }else if(i==4){
                //     this.configList[i].val = data.lijupercent
                // }else if(i==5){
                //     this.configList[i].val = data.windspeed
                // }else if(i==6){
                //     this.configList[i].val = data.fall
                // }
            }
        },

        //配置
        config(){
            this.dialogTitle = '参数配置'
            this.editFormVisible = true
            this.configData.projectId = util.session.get('groupId')
            this.configData.projectName = this.projectName
            var that = this
            for(var i in this.configData){
                this.configData[i] = ''
            }
            this.setConfigList(this.configData)
            myHttp.selectTowerCopy({
                projectId:util.session.get('groupId'),
                deviceId:this.deviceId
            }).then(function(resp){
                if(resp.data.code=='200'){
                var data = resp.data.data.TowerCopy
                if(data){
                    that.hasConf = true
                    that.configData = data
                    that.setConfigList(data)
                }else{
                    that.hasConf = false
                }
                }else{
                that.$message.error(resp.data.msg)
                }
            })
        },
        // 基本参数配置
        baseconfig (){
            this.configFormVisible = true
            // selectTowerBasicConfiguration
            this.heightSensor={
              height_max:'', //高度传感器上限
              height_min:'',//高度传感器下限
              height_max_distance:'',//吊钩距离大臂上限
              height_min_distance:'',//吊钩距离大臂下限
            }
            this.radiusSensor={
              radius_max:'',//幅度传感器上限
              radius_min:'',//幅度传感器下限
              radius_max_distance:'',//幅度传感器小车距离上限
              radius_min_distance:'',//幅度传感器小车距离下限
            }
            var that = this
            myHttp.selectTowerBasicConfiguration({
                projectId:util.session.get('groupId'),
                imei:this.deviceId
            }).then(function(resp){
                if(resp.data.code=='200'){
                 var data = resp.data.data
                 if(data.heightSensor){
                  that.heightSensor = JSON.parse( data.heightSensor)
                 }
                 if(data.radiusSensor){
                   that.radiusSensor = JSON.parse( data.radiusSensor)
                 }
                }else{
                that.$message.error(resp.data.msg)
                }
            })
        },

        // 心跳设置
        breat(){
          var that = this
          var beatForm = {

          }
          this.beatFormVisible = true
            myHttp.getTowerInfoByPage({
                projectId:util.session.get('groupId'),
                id:this.towerId
            }).then(function(resp){
                if(resp.data.code=='200'){
                  console.log(resp)
                 var data = resp.data.data.tower
                 that.beatForm = data
                
                }else{
                that.$message.error(resp.data.msg)
                }
            })

        },
        // 确定配置
        configRow(formName){
          var that = this
          var heightSensor = JSON.stringify( this.heightSensor)
          var radiusSensor = JSON.stringify( this.radiusSensor)
          myHttp.updateTowerBasicConfiguration({
            imei:this.deviceId,
            heightSensor:heightSensor,
            radiusSensor:radiusSensor
          }).then(function(resp){
          if(resp.data.code=='200'){
              that.$message.success('配置成功')
              that.configFormVisible = false
          }else{
              that.$message.error(resp.data.msg)
          }
          })
        },
       
        // 维护环境标准configData
        sumbitEditRow(formName) {
            var that = this
            for(var i=0;i<this.configList.length;i++){
                this.configData[this.configList[i].key] = this.configList[i].val
                // if(i==0){
                // this.configData.angle = this.configList[i].val
                // this.configData.angleSwitch = this.configList[i].status=='1'?'1':'2'
                // }else if(i==1){
                // this.configData.radius = this.configList[i].val
                // this.configData.radiusSwitch = this.configList[i].status=='1'?'1':'2'
                // }else if(i==2){
                // this.configData.hight = this.configList[i].val
                // this.configData.hightSwitch = this.configList[i].status=='1'?'1':'2'
                // }else if(i==3){
                // this.configData.loadweightr = this.configList[i].val
                // this.configData.loadweightrSwitch = this.configList[i].status=='1'?'1':'2'
                // }else if(i==4){
                // this.configData.lijupercent = this.configList[i].val
                // this.configData.lijupercentSwitch = this.configList[i].status=='1'?'1':'2'
                // }else if(i==5){
                // this.configData.windspeed = this.configList[i].val
                // this.configData.windspeedSwitch = this.configList[i].status=='1'?'1':'2'
                // }else if(i==6){
                // this.configData.fall = this.configList[i].val
                // this.configData.fallSwitch = this.configList[i].status=='1'?'1':'2'
                // }
            }
            delete this.configData.createDate
            delete this.configData.updateDate
            this.configData.deviceId = this.deviceId
            this.configData.projectId = util.session.get('groupId')
            if(this.hasConf){
                this.configData.updateBy = util.session.get('user').id
                myHttp.updateTowerCopy(this.configData).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message.success('配置成功')
                    that.editFormVisible = false
                }else{
                    that.$message.error(resp.data.msg)
                }
                })
            }else{
                this.configData.createBy = util.session.get('user').id
                myHttp.addTowerCopy(this.configData).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message.success('配置成功')
                    that.editFormVisible = false
                }else{
                    that.$message.error(resp.data.msg)
                }
                })
            }
        },
        //恢复默认值
        setDetfaule(){
            for(var i=0;i<this.configList.length;i++){
                this.configList[i].val = this.configList[i].default
            }
        },

        //展示列表
        toMore(){
          if(this.deviceId){
            this.$router.push({path:'/towerWarn/'+this.deviceId})
          }else{
            this.$message.error('暂无更多')
          }
           
        },
    }
}
</script>
<style scoped>
    @import '../../../assets/css/clock.css';
    .main-left{
        width: 10vw;
        height: 100%;
        position: relative;
        padding: 1vh 0.6vh;
        display: flex;
        flex-wrap: wrap;
        overflow: auto;
        background: #fff;
        align-content: flex-start;
    }
    .main-left-item{
        height: 7vh;
        width: 100%;
        position: relative;
        background: #E7F1FB;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        padding: 0.5vh;
        cursor: pointer;
        margin-top: 1vh;
    }
    .main-left-item p{
        height: 3vh;
        position: relative;
        text-align: left;
        display: flex;
        align-content: center;
        align-items: center;
    }
    .main-left-item .name{
        width: calc( 100% - 3vw );
        position: relative;
    }
    .main-left-item .state{
        width: 3vw;
        position: relative;
        justify-content: flex-end;
    }
    .main-left-item .num{
        width: 100%;
        position: relative;
    }
    .curTower{
        background: #1E369A;
    }
    .curTower .name,.curTower .state,.curTower .num{
        color: #fff;
    }

    .main-right{
        width: calc( 100% - 10vw );
        height: 100%;
        position: relative;
        padding: 0 1vh;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow:auto;
    }
    .main-right-first{
        width: 100%;
        height: 32vh;
        position: relative;
        border-radius: 6px;
        background: #fff;
        display: flex;
        flex-wrap: wrap;
        min-height: 260px;
    }
    .real-data{
        width: 33%;
        height: 100%;
        position: relative;
        padding: 1vh;
        display: flex;
        flex-wrap: wrap;
    }
    .real-data-l,.real-data-r{
        width:50%;
        height:calc( 100% - 3vh );
        padding:2vh 0;
    }
    .real-data-l-item{
        width:100%;
        display:flex;
        height:6vh;
        align-items: flex-end;
        margin-bottom: 1vh;
    }
    .real-data-l-item span{
        display: inline-block;
        /* width: 10vw; */
        margin-left: 0.8vw;
        height: 4vh;
        display: flex;
        align-content: center;
        align-items: center;
    }
    .real-data-l-item .abr{
        position: absolute;
        bottom: 2vh;
        left: 60%;
        width: 3.5vw;
        height: 3vh;
        /* line-height: 25px; */
        font-size: 0.8vw;
        text-align: center;
        color: #707070;
        background: #c5c1c1;
        background: url(../../../assets/image/box.png) no-repeat;
        background-size: 100% 100%;
    }
    .real-clock{
        width: 25%;
        height: 100%;
        position: relative;
        padding: 1vh;
    }
    #wrap.real-clock-con{
        /* width:100%;
        height:calc( 100% - 3vh ); */
        /* padding:2vh 0; */
        margin-top: 3vh;
        width: 220px;
        height: 220px;
    }
    .main-dure{
        width:70%;
        height:100%;
        position: relative;
        padding-left:2vw;
        display:flex;
        flex-wrap:wrap;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }
    .main-dure p{
        width: 100%;
        position: relative;
        height:4vh;
        display:flex;
     }
     .main-dure p span{
         width: 16.6%;
         position: relative;
     }
     .special-table{
         width: 100%;
         height: calc( 100% - 3vh );
         position: relative;
         padding: 1vh;
     }
     .no-photo{
         width:6vh;
         height:6vh;
         display: flex;
         justify-content: center;
         justify-items: center;
         align-content: center;
         background: #F5F7FA;
         flex-wrap: wrap;
         color:#C0C4CC;
     }
     .item-info{
        width: 100%;
        height: 5vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: space-around;
        background: #E7F1FB;
    }
    .item-info .name{
        flex:1;
        text-align: center;
        
    }
    .item-info img{
        width:1.5vw;
        height: auto;
        position: relative;
        margin: 0 1vw;
    }
 
</style>
<style>
    .real-data .el-progress-bar__outer{
        background: #69BCFF;
    }
    @import '../../../assets/css/common.css';
    .tower-dig .el-dialog__title{
      color: #0085FF;
    }
    .tower-dig .el-dialog__body,.tower-dig .el-dialog__footer{
      border-top: 1px solid #ddd;
    }
    .tower-dig span{
      font-weight: bold;
    }
    .tower-dig .el-dialog__header{
      text-align: left;
    }
    .config-con{
      display:flex;
      flex-wrap:wrap;
      width:100%;
      height:auto;
    }
    .config-con-item{
      width:100%;
      padding:1vh 0;
      display:flex;
      justify-content: space-around;
      align-items: center;
      align-content: center;
    }
    .item-one{
      width:100%;
      display: flex;
      align-items: center;
      margin-top: 20px ;
    }
</style>